import { MockMethod } from 'vite-plugin-mock';

export default [
    {
        url: '/mock/website/company/info/intro',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: {
                    bannerImageUrl: '',
                    bannerVideoUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/62f9c42843f44583a283eb0cccd42e41/video-banner.mp4',
                    companyLogo: 'https://oss.zeewain.com/WEBSITE_RESOURCE/e641bab52eb849df9e0e3e11662daa12/01%E5%89%8D%E5%8F%B0.jpg',
                    companyIntro: `紫为云始终秉承“清华AI使能”理念，依托沉浸式AI引擎（Zee引擎）技术
和UGC内容生产创新，打造虚实交互的技术底座，构建链接虚实世界的视能
空间，致力于探索AI创新技术产业化之路，促进跨媒体智能场景应用落地，
持续推动人工智能与数字经济融合，使人们不断享有交互、拟真、丰富的超
现实体验新生活！`
                },
                message: 'success'
            };
        }
    },
    {
        url: '/mock/website/company/ideas',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: [
                    {
                        imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/b1c22ecc8b2b4aa0b351ad3430517933/idea-1.jpg',
                        title: '文化内核',
                        desc: '自强不息、厚德载物、行胜于言'
                    },
                    {
                        imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/eab0e3a1a463497c8a277b9782edae8f/idea-3.jpg',
                        title: '理  念',
                        desc: '专业创新、责任进取、智信分享'
                    },
                    {
                        imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/3147d1c47d1744ba8c1ec2257c431bc3/idea-2.jpg',
                        title: '愿  景',
                        desc: '持续引领人工智能技术发展，使人们不断享有智能创新的美好生活'
                    },
                    {
                        imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/e4dcda043efe4c6d9f85e0756459f825/idea-4.jpg',
                        title: '使  命',
                        desc: '成为世界一流的AI使能平台，让人工智能服务更简单、更便捷！'
                    },
                    {
                        imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/bf1343d3c3434eddb78b9922b9cc4862/idea-5.jpg',
                        title: '定  位',
                        desc: '专注交互式人工智能技术，打造AR虚实交互的技术底座'
                    }
                ],
                message: 'success'
            };
        }
    },
    {
        url: '/mock/website/company/honour/list',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: [
                    {
                        awardTime: 2021,
                        awardName: ' 粤港澳大湾区新经济先锋企业50强',
                        awardUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/64265725ae68416d8429a2485e6dfde5/honour-1.jpg'
                    },
                    {
                        awardTime: 2021,
                        awardName: 'iResearch Awards金瑞奖—最佳创新企业奖',
                        awardUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/3105cf2c12414f76b273ee004c240ac3/honour-2.jpg'
                    },
                    {
                        awardTime: 2021,
                        awardName: ' 第九届中国创新创业大赛第4名（广州赛区）',
                        awardUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/e72f40c330c94ddd9c7d9b092456afb6/honour-3.jpg'
                    },
                    {
                        awardTime: 2020,
                        awardName: '金瑞奖—最佳创新企业奖',
                        awardUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/64265725ae68416d8429a2485e6dfde5/honour-1.jpg'
                    },
                    {
                        awardTime: 2020,
                        awardName: ' 第八届中国创新创业大赛第1名',
                        awardUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/e72f40c330c94ddd9c7d9b092456afb6/honour-3.jpg'
                    }
                ],
                message: 'success'
            };
        }
    },
    {
        url: '/mock/website/company/timeline',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: [
                    {
                        developTimeline: '2017',
                        developDesc: '人脸识别在国际权威1：N百万级人脸库Megaface上评测取得一项第一'
                    },
                    {
                        developTimeline: '2018',
                        developDesc: '2018年车辆检测在KITTI数据集刷新国际最高性能指标'
                    },
                    {
                        developTimeline: '2019',
                        developDesc: `荣获“2019 年ICCV人与物体关系推理挑战赛”第二名
                        “第九届吴文俊人工智能科学技术创新奖”二等奖`
                    },
                    {
                        developTimeline: '2020',
                        developDesc: `荣获“国际无人驾驶KITTI车辆检测评测”第一名
                        “第九届中国创新创业大赛”第4名（广州赛区）`
                    },
                    {
                        developTimeline: '2021',
                        developDesc: '荣获权威机构艾瑞咨询主办的“2021最佳创新企业金瑞奖”'
                    },
                    {
                        developTimeline: '未来',
                        developDesc: '无限可能'
                    }
                ],
                message: 'success'
            };
        }
    },
    {
        url: '/mock/website/company/party/list',
        method: 'post',
        response: (option:any) =>
        {
            console.log('option' + option);
            if (option.partyType === 2)
            {

                return {
                    code: 0,
                    data: [
                        {
                            partyName: '',
                            partyIntro: '',
                            imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/6d095063cfd542c6a70e641d6ccd2e10/pic-4.jpg'
                        },
                        {
                            partyName: '',
                            partyIntro: '',
                            imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/84f9f2227603495e8358f41428de7f9c/pic-3.jpg'
                        },
                        {
                            partyName: '',
                            partyIntro: '',
                            imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/2021658f22a646c5b2161f43bcdd8cc1/pic-2.jpg'
                        },
                        {
                            partyName: '',
                            partyIntro: '',
                            imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/8caa8898b3844d2aaa8c1c990b4c8cb1/pic-1.jpg'
                        }
                    ],
                    message: 'success'
                };
            }
            else
            {
                return {
                    code: 0,
                    data: [
                        {
                            tid: '1',
                            imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/12fca8f8777b4e119113ebc1cd155e79/news-1.jpeg',
                            partyName: '奋斗百年路，开启新征程庆祝建党100周年',
                            partyIntro: '2021年7月1日，在建党100周年的日子，紫为云科技公司全\n' +
                                '体员工在CEO顾友良的带领下，开展了“百年荣光，高歌奋\n' +
                                '进”全天的团建活动。',
                            partyTime: '2021-6-29'
                        },
                        {
                            tid: '2',
                            imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/c62dc24b2fac4b6b93aadad1419c35af/news-2.jpeg',
                            partyName: '奋斗百年路，开启新征程庆祝建党100周年',
                            partyIntro: '2021年7月1日，在建党100周年的日子，紫为云科技公司全\n' +
                                '体员工在CEO顾友良的带领下，开展了“百年荣光，高歌奋\n' +
                                '进”全天的团建活动。',
                            partyTime: '2021-6-29'
                        },
                        {
                            tid: '3',
                            imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/716930c6b5f04e818627b45b3dd1a704/news-3.jpeg',
                            partyName: '奋斗百年路，开启新征程庆祝建党100周年',
                            partyIntro: '2021年7月1日，在建党100周年的日子，紫为云科技公司全\n' +
                                '体员工在CEO顾友良的带领下，开展了“百年荣光，高歌奋\n' +
                                '进”全天的团建活动。',
                            partyTime: '2021-6-29'
                        },
                        {
                            tid: '4',
                            imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/c62dc24b2fac4b6b93aadad1419c35af/news-2.jpeg',
                            partyName: '奋斗百年路，开启新征程庆祝建党100周年',
                            partyIntro: '2021年7月1日，在建党100周年的日子，紫为云科技公司全\n' +
                                '体员工在CEO顾友良的带领下，开展了“百年荣光，高歌奋\n' +
                                '进”全天的团建活动。',
                            partyTime: '2021-6-29'
                        },
                        {
                            tid: '5',
                            imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/716930c6b5f04e818627b45b3dd1a704/news-3.jpeg',
                            partyName: '奋斗百年路，开启新征程庆祝建党100周年',
                            partyIntro: '2021年7月1日，在建党100周年的日子，紫为云科技公司全\n' +
                                '体员工在CEO顾友良的带领下，开展了“百年荣光，高歌奋\n' +
                                '进”全天的团建活动。',
                            partyTime: '2021-6-29'
                        }
                    ],
                    message: 'success'
                };
            }
        }
    },
    {
        url: '/mock/website/company/party/info',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: {
                    tid: '3',
                    imageUrl: 'https://zeewain-app-store.oss-cn-hangzhou.aliyuncs.com/TEMP/716930c6b5f04e818627b45b3dd1a704/news-3.jpeg',
                    partyName: '泛珠三角+大学生科创硕果累累，清华“紫为云”为其加持助威',
                    partyIntro: '<p><span style=";font-family:宋体">10</span><span style=";font-family:宋体">月29日，来自全国各地安防协会的领导、安防企业负责人及从业人员300多人在各地安防协会的组织下，在深圳福田香格里拉酒店共同见证了“粤港澳大湾区智能安防产业与技术创新联盟”的成立盛典，也见证了“清华AI使能平台及王牌来了AI-Open Club”《深圳联合宣言》的发布。</span></p><p style="text-align: center;"><img class="loadingclass" id="loading_k4dx49eh" src="/static/ueditor1_4_3_3/themes/default/images/spacer.gif" title="正在上传..."/>&nbsp;</p><p><span style="font-family:宋体">全国安防协会互助联盟理事长、深圳市安全防范行业协会会长杨金才为大会发来了视频祝贺，并委托特别代表</span><span style=";font-family:宋体">王达宣读了贺信。杨金才表示，去年以来，数字广东、粤港澳大湾区规划、深圳先行示范区等政策规划，将在人工智能、大数据、AIoT、云技术、5G、机器人、无人机、生物科技、新能源、新材料、先进制造、数字经济等一系列新技术和新应用领域掀起建设的高潮。“粤港澳大湾区智能安防产业与技术创新联盟”因势而生，抓住了时代的脉搏，契合了国家建设的进程，为大湾区广大安防企业向新技术创新和应用领域进军搭建了发展的平台。相信联盟在未来的发展中可以为广大安防企业和从业人员提供高质量的服务，进而推动大湾区企业的创新与成长。</span></p><p>&nbsp;</p><p><span style="font-family:宋体">杨金才指出，在改革开放</span>40<span style="font-family:宋体">周年之际，</span><span style=";font-family:宋体">清华AI使能平台</span><span style="font-family: 宋体">与深圳这个城市一起站在了时代的潮头！他祝愿风华正茂的清华大学</span>AI<span style="font-family:宋体">使能团队用聪明才智，做好科研，做好使能，为产业积极构建</span>AI<span style="font-family:宋体">生态圈，为深圳、为广东、为国家“智能</span>+<span style="font-family:宋体">”战略目标的实现做出积极的贡献！</span></p><p style="text-align:center"><br/></p><p><span style=";font-family:宋体">由清华大学硕士、紫为云清华AI使能平台负责人王建强带队的清华AI使能团队在会上宣读了《致</span><span style="font-family:宋体">﹒最美的青春》宣言。</span><span style=";font-family:宋体">他们表示，要将最美的青春绽放在最美的深圳，在先行示范的改革洪流里，扬起使能的风帆，奏响数据时代的强音！</span></p><p><span style=";font-family:宋体"><br/></span></p><p style="text-align: center;"><span style=";font-family:宋体"></span></p><p><span style=";font-family:宋体">会上，鹏城实验室、新一代人工智能产业与创新联盟刘明博士，清华大学硕士、紫为云清华AI使能平台负责人王建强，中安协战略专家组组长、广州安协会长、联盟理事长顾友良，佳都科技副总裁张进飞，广州市安全防范行业协会秘书长、联盟秘书长杨勇分别围绕人工智能的开源、使能、落地应用、发展趋势与热点、未来的远景等话题做了精彩演讲。</span></p><p><br/></p>',
                    createTime: '2021-04-23'
                },
                message: 'success'
            };
        }
    }

] as MockMethod[];
